<template>
  <div class="container" v-if="curYoukeLaiyuanDetailData">
    <Header status="simple" />
    <div @click="$router.go(-1)" class="btn-icon back-btn">
      <div>
        <img src="../assets/back.png" />
      </div>
      <div>返回客情</div>
    </div>
    <MapTitle :data="mapTitleData" :marginTop="-0.4" @getCurTab="setCurtab" />
    <div>
      <Transfermap :chartData="curYoukeLaiyuanDetailData" :legendColor="legendColor" v-if="curTab == 0" />
      <AmapScatter :chartData="curYoukeLaiyuanDetailData" :legendColor="legendColor" v-if="curTab == 1" />
      <AmapRange :chartData="curYoukeLaiyuanDetailData" :legendColor="legendColor2" v-if="curTab == 2" />
      <Linemap :legendColor="legendColor" :legendConf="ShengneiChuyouGuanxiDetailData.legendConf" :lineData="ShengneiChuyouGuanxiDetailData.lineData" :title="ShengneiChuyouGuanxiDetailData.title" v-if="curTab == 3" />
    </div>
    <div class="left-content" v-if="curTab != 3">
      <BScroll>
        <div>
          <BasePanel title="游客省内外来源对比图">
            <div class="bottom-info">
              <div class="left">
                省内来源
                <span>57万</span>
              </div>
              <div class="right">
                省外来源
                <span>137万</span>
              </div>
            </div>
          </BasePanel>
          <BasePanel :style="{marginTop: '-1.1rem'}" :title="curTab == 0 ? '游客来源省份详细统计' : '游客来源城市top值'">
            <RankBar :chartData="curYoukeLaiyuanDetailData.sourceArea" :lineNum="999" id="youkelaiyuan-youkelaiyuan" marginBottom="0.18rem" rect="yes" />
          </BasePanel>
        </div>
      </BScroll>
    </div>
    <div class="legend my-amap-legend" v-if="curTab != 3">
      <div class="title">{{curTab == 2 ? '来源距离(km)' : '游客量'}}</div>
      <ul>
        <li :key="index" v-for="(item, index) in curYoukeLaiyuanDetailData.legendConf">
          <div class="rect">
            <div
              :style="{
                height: '0.05rem',
                background: curTab == 2 ? legendColor2[index] : legendColor[index],
                boxShadow: '0 0 5px ' + (curTab == 2 ? legendColor2[index] : legendColor[index])
              }"
              class="rect-in"
            ></div>
          </div>
          <div class="num">{{ item.max ? item.min + "-" + item.max : ">" + item.min }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Common/Header.vue'
import BasePanel from '@/components/Common/BasePanel.vue'
import MapTitle from '@/components/Common/MapTitle.vue'
import Transfermap from '@/components/Echarts/AmapTransfermap.vue'
import AmapScatter from '@/components/Echarts/AmapScatter.vue'
import AmapRange from '@/components/Echarts/AmapRange.vue'
import BScroll from '@/components/Common/BScroll.vue'
import RankBar from '@/components/Mycharts/RankBar.vue'
import Linemap from '@/components/Loca/Linemap.vue'

export default {
  name: 'YoukeLaiyuan',
  components: {
    Header,
    BasePanel,
    MapTitle,
    Transfermap,
    AmapScatter,
    AmapRange,
    BScroll,
    RankBar,
    Linemap
  },
  data() {
    return {
      mapTitleData: {
        title: '',
        tab: ['来源省统计', '来源城市统计', '辐射范围', '省内出游关系']
      },
      curTab: 0,
      panelFlag: true,
      YoukeLaiyuanDetailData: null,
      YoukeLaiyuanDetailData2: null,
      YoukeLaiyuanDetailData3: null,
      curYoukeLaiyuanDetailData: null,
      legendColor: ['#DA221A', '#FF852F', '#F5E047', '#6BF15c', '#34B7ED'],
      legendColor2: ['#23fe7c', '#3080f9', '#f6191e']
    }
  },
  mounted() {
    // 请求
    fetch('/data/Home/ShengneiChuyouGuanxiDetail.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.ShengneiChuyouGuanxiDetailData = json.data
      })
    // 请求地图数据
    fetch('/data/Home/YoukeLaiyuanDetail.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.YoukeLaiyuanDetailData = json.data
        this.mapTitleData.title = json.data.title
        this.curYoukeLaiyuanDetailData = this.YoukeLaiyuanDetailData
      })
    fetch('/data/Home/YoukeLaiyuanDetail2.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.YoukeLaiyuanDetailData2 = json.data
        this.mapTitleData.title = json.data.title
      })
    fetch('/data/Home/YoukeLaiyuanDetail3.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.YoukeLaiyuanDetailData3 = json.data
        this.mapTitleData.title = json.data.title
        // 先根据sourceArea洗legendConf
        this.YoukeLaiyuanDetailData3.legendConf = [{}, {}, {}]
        var legendMax =
          Math.ceil(this.YoukeLaiyuanDetailData3.sourceArea[0].num / 100) * 100
        var legendMid =
          Math.ceil(
            this.YoukeLaiyuanDetailData3.sourceArea[
              Math.round(this.YoukeLaiyuanDetailData3.sourceArea.length / 2) - 1
            ].num / 100
          ) * 100
        var legendMin =
          Math.ceil(
            this.YoukeLaiyuanDetailData3.sourceArea[
              this.YoukeLaiyuanDetailData3.sourceArea.length - 1
            ].num / 100
          ) * 100
        this.YoukeLaiyuanDetailData3.legendConf[0].max = legendMax
        this.YoukeLaiyuanDetailData3.legendConf[0].min = legendMid
        this.YoukeLaiyuanDetailData3.legendConf[1].max = legendMid
        this.YoukeLaiyuanDetailData3.legendConf[1].min = legendMin
        this.YoukeLaiyuanDetailData3.legendConf[2].max = legendMin
        this.YoukeLaiyuanDetailData3.legendConf[2].min = 0
      })
  },
  methods: {
    setCurtab(val) {
      this.curTab = val
    }
  },
  watch: {
    curTab(val) {
      if (val == 0) {
        this.curYoukeLaiyuanDetailData = this.YoukeLaiyuanDetailData
      } else if (val == 1) {
        this.curYoukeLaiyuanDetailData = this.YoukeLaiyuanDetailData2
      } else if (val == 2) {
        this.curYoukeLaiyuanDetailData = this.YoukeLaiyuanDetailData3
      }
    }
  }
}
</script>
<style scoped lang="less">
.container {
  .back-btn {
    left: 0.6rem;
    top: 0.8rem;
  }
  .left-content {
    width: 4.1rem;
    height: 84%;
    left: 0.6rem;
    top: 1.3rem !important;
    overflow: hidden;
    .rank-bar li {
      margin: 0 0 0.24rem;
    }
    .bottom-info {
      margin-top: 0.28rem;
      font-weight: bold;
      .left {
        float: left;
      }
      .right {
        float: right;
      }
    }
    .bottom-info > div {
      width: 50%;
      height: 0.4rem;
      background: url(../assets/youkelianggaikuang/btn_bg.png) no-repeat
        center center;
      background-size: 95% 100%;
      text-align: center;
      line-height: 0.4rem;
    }
    .bottom-info > div > span {
      color: #00ccff;
      font-size: 0.22rem;
      margin: 0 0.04rem;
    }
  }
}
</style>
